import { DocumentAddedBy } from '@models/Document.model';
import COLORS_FLAT, {
  T_COLOR_SHADES,
} from '@styles/colors/themes/beam/beam-flat';
import { ReactComponent as InternalSign } from '@assets/svg/internal-sign.svg';

export function getSourceIcon(addedBy: DocumentAddedBy) {
  if (addedBy === DocumentAddedBy.internal) {
    return {
      iconJsx: <InternalSign color={COLORS_FLAT.n600} />,
      color: 'n700' as T_COLOR_SHADES,
    };
  }
  return {};
}
